import { combineReducers } from "redux";

// reducer import
// auth reducer
import authReducer from "../features/authSlice";
// auth reducer
import customizationReducer from "./customizationReducer";
import companyReducer from "./companyReducer";
import financialForecastReducer from "./assumptions/financialForecastReducer";
import subscriberAcquisitionAssumptionsReducer from "./assumptions/subscriberAcquisitionAssumptionsReducer";
import netWorkingCapitalAssumptionsReducer from "./assumptions/netWorkingCapitalAssumptionsReducer";
import capexAssumptionsReducer from "./assumptions/capexAssumptionsReducer";
import newInstallsReducer from "./subscriber-acquisitions/newInstallsReducer";
import cumulativeInstallsReducer from "./subscriber-acquisitions/cumulativeInstallsReducer";
import cumulativeMembersReducer from "./subscriber-acquisitions/cumulativeMembersReducer";
import cumulativeSubscribersReducer from "./subscriber-acquisitions/cumulativeSubscribersReducer";
import subscriptionRevenueReducer from "./revenue/subscriptionRevenueReducer";
import subscriptionCommissionsReducer from "./revenue/subscriptionCommissionsReducer";
import otherRevenueReducer from "./revenue/otherRevenueReducer";
import unitSalesReducer from "./revenue/unitSalesReducer";
import billableHoursReducer from "./revenue/billableHoursReducer";
import recurringChargesReducer from "./revenue/recurringChargesReducer";
import generalOtherRevenueReducer from "./revenue/generalOtherRevenueReducer";
import costOfSalesReducer from "./cost-and-expenses/costOfSalesReducer";
import costOfSalesContdReducer from "./cost-and-expenses/costOfSalesContdReducer";
import generalAdministrativeExpensesReducer from "./cost-and-expenses/generalAdministrativeExpensesReducer";
import salesAndMarketingExpensesReducer from "./cost-and-expenses/salesAndMarketingExpensesReducer";
import advertisementExpensesReducer from "./cost-and-expenses/advertisementExpensesReducer";
import otherAdvertisementAndMarketingExpenseReducer from "./cost-and-expenses/otherAdvertisementAndMarketingExpensesReducer";
import hpFoundersAndPartnersReducer from "./hiring-plan/foundersAndPartnersReducer";
import hpTechAndProductDevReducer from "./hiring-plan/techProductDevReducer";
import hpSalesAndMarketingReducer from "./hiring-plan/salesAndMarketingReducer";
import hpFinanceAndAnalyticsReducer from "./hiring-plan/financeAndAnalyticsReducer";
import hiringPlanOtherReducer from "./hiring-plan/hiringPlanOtherReducer";
import hiringPlanAverageReducer from "./hiring-plan/hiringPlanAverageReducer";
import profitAndLossMainReducer from "./profit-and-loss/mainReducer";
import freeCashFlowMainReducer from "./free-cash-flow/mainReducer";
import loaderReducer from "./loaderReducer";

// ==============================|| COMBINE REDUCERs ||============================== //

export const CUSTOMIZATION_REDUCER_KEY = "customization";
export const COMPANY_REDUCER_KEY = "company";
export const FINANCIAL_FORECAST_REDUCER_KEY = "financialForecast";
export const SUBSCRIBER_ACQUISITION_ASSUMPTIONS_REDUCER_KEY =
  "subscriberAcquisitionAssumptions";
export const NET_WORKING_CAPITAL_ASSUMPTIONS_REDUCER_KEY =
  "netWorkingCapitalAssumptions";
export const CAPEX_ASSUMPTIONS_REDUCER_KEY = "capexAssumptions";
export const NEW_INSTALLS_REDUCER_KEY = "newInstalls";
export const CUMULATIVE_INSTALLS_REDUCER_KEY = "cumulativeInstalls";
export const CUMULATIVE_MEMBERS_REDUCER_KEY = "cumulativeMembers";
export const CUMULATIVE_SUBSCRIBERS_REDUCER_KEY = "cumulativeSubscribers";

// revenue reducers
export const SUBSCRIPTION_REVENUE_REDUCER_KEY = "subscriptionRevenue";
export const SUBSCRIPTION_COMMISSIONS_REDUCER_KEY = "subscriptionCommissions";
export const OTHER_REVENUE_REDUCER_KEY = "otherRevenue";
export const UNIT_SALES_REDUCER_KEY = "unitSales";
export const BILLABLE_HOURS_REDUCER_KEY = "billableHours";
export const RECURRING_CHARGES_REDUCER_KEY = "recurringCharges";
export const GENERAL_OTHER_REVENUE_REDUCER_KEY = "generalOtherRevenue";

// cost and expenses reducers
export const COST_OF_SALES_REDUCER_KEY = "costOfSales";
export const COST_OF_SALES_CONTD_REDUCER_KEY = "costOfSalesContd";
export const GENERAL_ADMINISTRATIVE_EXPENSES_REDUCER_KEY =
  "generalAdministrativeExpenses";
export const SALES_AND_MARKETING_EXPENSES_REDUCER_KEY =
  "salesAndMarketingExpenses";
export const ADVERTISEMENT_EXPENSES_REDUCER_KEY = "advertisementExpenses";
export const OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_REDUCER_KEY =
  "otherAdvertisementAndMarketingExpenses";

// hiring plan reducers
export const FOUNDERS_AND_PARTNERS_REDUCER_KEY = "hp_foundersAndPartners";
export const TECH_AND_PRODUCT_DEV_REDUCER_KEY = "hp_techAndProductDev";
export const SALES_AND_MARKETING_REDUCER_KEY = "hp_salesAndMarketing";
export const HP_FINANCE_AND_ANALYTICS_REDUCER_KEY = "hp_financeAndAnalytics";
export const HIRING_PLAN_OTHER_REDUCER_KEY = "hp_other";
export const HIRING_PLAN_AVERAGE_REDUCER_KEY = "hp_average";

// profit and loss reducers
export const PROFIT_AND_LOSS_MAIN_REDUCER_KEY = "pnl_main";

// free cash flow reducers
export const FREE_CASH_FLOW_MAIN_REDUCER_KEY = "fcf_main";

export const LOADERS = "loaders";

const reducer = combineReducers({
  auth: authReducer,
  customization: customizationReducer,
  company: companyReducer,
  financialForecast: financialForecastReducer,
  subscriberAcquisitionAssumptions: subscriberAcquisitionAssumptionsReducer,
  netWorkingCapitalAssumptions: netWorkingCapitalAssumptionsReducer,
  capexAssumptions: capexAssumptionsReducer,
  newInstalls: newInstallsReducer,
  cumulativeInstalls: cumulativeInstallsReducer,
  cumulativeMembers: cumulativeMembersReducer,
  cumulativeSubscribers: cumulativeSubscribersReducer,

  // Revenue reducers
  subscriptionRevenue: subscriptionRevenueReducer,
  subscriptionCommissions: subscriptionCommissionsReducer,
  otherRevenue: otherRevenueReducer,
  unitSales: unitSalesReducer,
  billableHours: billableHoursReducer,
  recurringCharges: recurringChargesReducer,
  generalOtherRevenue: generalOtherRevenueReducer,

  costOfSales: costOfSalesReducer,
  costOfSalesContd: costOfSalesContdReducer,
  generalAdministrativeExpenses: generalAdministrativeExpensesReducer,
  salesAndMarketingExpenses: salesAndMarketingExpensesReducer,
  advertisementExpenses: advertisementExpensesReducer,
  otherAdvertisementAndMarketingExpenses:
    otherAdvertisementAndMarketingExpenseReducer,
  hp_foundersAndPartners: hpFoundersAndPartnersReducer,
  hp_techAndProductDev: hpTechAndProductDevReducer,
  hp_salesAndMarketing: hpSalesAndMarketingReducer,
  hp_financeAndAnalytics: hpFinanceAndAnalyticsReducer,
  hp_other: hiringPlanOtherReducer,
  hp_average: hiringPlanAverageReducer,
  [PROFIT_AND_LOSS_MAIN_REDUCER_KEY]: profitAndLossMainReducer,
  [FREE_CASH_FLOW_MAIN_REDUCER_KEY]: freeCashFlowMainReducer,
  [LOADERS]: loaderReducer,
});

export default reducer;
